import { TempleRegistration } from './types';

// Helper function to get correct asset URL (removes duplicate /uploads)
export const getAssetUrl = (path: string | undefined): string => {
    if (!path) return '';
    // Remove /uploads prefix if path starts with it, since ASSET_URL already includes /uploads
    let cleanPath = path;
    if (cleanPath.startsWith('/uploads')) {
        cleanPath = cleanPath.substring('/uploads'.length);
    }
    // Ensure path starts with /
    if (!cleanPath.startsWith('/')) {
        cleanPath = '/' + cleanPath;
    }
    // ASSET_URL already ends with /uploads, so just append the clean path
    const assetBaseUrl = process.env.REACT_APP_ASSET_URL || 'http://localhost:3002/uploads';
    return `${assetBaseUrl}${cleanPath}`;
};

export const getDisplayStatus = (registration: TempleRegistration) => {
    const val = registration.setupStatus;
    const mainStatus = registration.status;
    const v = registration.verificationStatus;

    // Check if strictly verified (all 3 pillars)
    const isStrictlyVerified = v?.certificate501c3?.status === 'verified' && 
                             v?.stateVerification?.status === 'verified' && 
                             v?.irsPropublica?.status === 'verified';
    
    if (val && val !== 'pending') {
         // If setup has started (in_progress / on_boarded), show that
        return val.replace('_', ' ').toUpperCase();
    } else if (mainStatus === 'approved' && isStrictlyVerified) {
         // Only show APPROVED if main status is approved AND all verifications passed
        return 'APPROVED';
    } else if (mainStatus === 'rejected') {
        return 'REJECTED';
    } else {
        // If pending, or approved but missing verification bits (shouldn't happen on strict backend), fallback
        return isStrictlyVerified ? 'APPROVED' : 'PENDING';
    }
};

export const getStatusBadgeColor = (status: string) => {
    if (status === 'APPROVED' || status === 'ON BOARDED') return 'bg-green-100 text-green-800';
    if (status === 'REJECTED') return 'bg-red-100 text-red-800';
    if (status === 'IN PROGRESS') return 'bg-yellow-100 text-yellow-800';
    return 'bg-gray-100 text-gray-800';
};
